import { Injectable } from "@angular/core";
import { UiSearchDefinitionService, WorkSearchFoundationService } from "e5core-angular-services";
import { SearchFormModel } from "../models/search-form.model";
import { Observable, BehaviorSubject, Subject } from "rxjs";

// import { UiSearchDefinitionService, FoundationWorkFindWorkItemResultModel, FoundationWorkFindWorkItemColumnDefModel, UIPropertyModel } from "e5core-angular-services";
// import { Injectable } from "@angular/core";
// import { BehaviorSubject, Subject, Observable } from "rxjs";
// import { WorkSearchFoundationService } from "e5core-angular-services";
// import { SearchFormModel } from "../models/search-form.model";
// import { SearchResultsModel, CreateBlankSearchResult } from "../models/search-results.model";
// import { SearchFilter, SearchFilterExpression } from "../models/search-filter.model";

// export class PerformSearchOptions {
//   attachmentTypeFilter?: any;
//   includeArchives?: boolean;
//   includeSla?: boolean;
//   includeAttachmentCount?: boolean;
//   includeNextDueTask?: boolean;
//   customProcedure?: string;
//   select?: string;
//   orderBy?: string;
//   siteGroupsFilter?: string;
//   page?: number;
//   pageSize?: number
// }

/**
 * This service is used to provide work into the work item Subject/
 */
@Injectable({
  providedIn: 'root'
})
export class SearchDeliveryService {

  constructor(
    private uiSearchDefinitionService: UiSearchDefinitionService,
    private workSearchService: WorkSearchFoundationService)
  {
  }

  /**
   * Get the search defintion, inclusing the fields to be shown by default, the search fields
   * and the default search information.
   * @param searchForm$ publish the new search definition to this observable.
   * @param searchDefinitionId
   */
  public getSearchDefinition(searchForm$: BehaviorSubject<SearchFormModel>, searchDefinitionId: number): Observable<SearchFormModel> {
    const subject$ = new Subject<SearchFormModel>();

    this.uiSearchDefinitionService.get(searchDefinitionId).subscribe(
      searchDefiniton => {
        let current = searchForm$.getValue();
        let updated: SearchFormModel = {
          ...current,
          ...searchDefiniton,
        };
        searchForm$.next(updated);
        subject$.next(updated);
      },
      error => subject$.error(error),
      () => subject$.complete()
    )

    return (subject$);
  }

//   /**
//    * Perform a new search with new search proeprties. This will replace the
//    * search properties in the SearchResultsModel so that they can be
//    * used when paging thought the results using the updateSearch() function.
//    * @param searchResults$
//    * @param searchForm$
//    * @param options
//    */
//   public performNewSearch(
//     searchResults$: BehaviorSubject<SearchResultsModel>,
//     searchForm$: BehaviorSubject<SearchFormModel>,
//     options?: PerformSearchOptions): Subject<SearchResultsModel>
//   {
//     const subject$ = new Subject<SearchResultsModel>();
//     const currentResults: SearchResultsModel = searchResults$.getValue();
//     const currentForm: SearchFormModel = searchForm$.getValue();

//     let filter = this.buildFilter(currentForm.properties);
//     let searchDefinitionId = currentForm.searchDefinitionId;
//     let defaultOptions = this.addDefaultSearchOptions(options) ;

//     this.workSearchService.getFindWorkItem(searchDefinitionId, filter, defaultOptions).subscribe(
//       results => {
//         // Construct a new Search
//         let newResults = CreateBlankSearchResult();
//         newResults.searchDefinitionId = currentForm.searchDefinitionId;
//         newResults.pageSize = results.pageSize;
//         newResults.page = results.page;
//         newResults.total = results.total;
//         newResults.searchFields = currentForm.searchFields;
//         newResults.properties = currentForm.properties;
//         newResults.results = null ; // this.mapResults(results);

//         searchResults$.next(newResults);
//         subject$.next(newResults);
//       },
//       error => subject$.error(error),
//       () => subject$.complete()
//     )
//     return (subject$);
//   }

//   ///
//   public clearResults(searchResults$: BehaviorSubject<SearchResultsModel>,
//     searchForm$: BehaviorSubject<SearchFormModel>,
//     options?: PerformSearchOptions): void
//   {
//     const currentForm: SearchFormModel = searchForm$.getValue();

//     let filter = this.buildFilter(currentForm.properties);
//     let searchDefinitionId = currentForm.searchDefinitionId;
//     let defaultOptions = this.addDefaultSearchOptions(options) ;

//     let newResults = CreateBlankSearchResult();
//     newResults.searchDefinitionId = currentForm.searchDefinitionId;
//     newResults.pageSize = 0;
//     newResults.page = 0;
//     newResults.total = 0;
//     newResults.searchFields = currentForm.searchFields;
//     newResults.properties = undefined ;
//     newResults.results = [] ;

//     searchResults$.next(newResults);
//   }

//   /**
//    * Update the SearchResultsModel with new data, this could be as a result or a page move or
//    * a refresh. The same proeprty filter is used as in the previous search, so no SearchForm
//    * is required.
//    * i.e. use the updateSearch() function when paging thought the results.
//    * @param searchResults$
//    * @param options
//    */
//   public updateSearch(
//     searchResults$: BehaviorSubject<SearchResultsModel>,
//     options?: PerformSearchOptions): Subject<SearchResultsModel>
//   {
//     const subject$ = new Subject<SearchResultsModel>();
//     const currentResults: SearchResultsModel = searchResults$.getValue();

//     let filter = this.buildFilter(currentResults.properties);
//     let searchDefinitionId = currentResults.searchDefinitionId;
//     let defaultOptions = this.addDefaultSearchOptions(options) ;

//     this.workSearchService.getFindWorkItem(searchDefinitionId, filter, defaultOptions).subscribe(
//       results => {
//         // Construct a new Search
//         let newResults = CreateBlankSearchResult();
//         newResults.searchDefinitionId = searchDefinitionId;
//         newResults.pageSize = results.pageSize;
//         newResults.page = results.page;
//         newResults.total = results.total;
//         newResults.searchFields = currentResults.searchFields;
//         newResults.properties = currentResults.properties;
//         newResults.results = this.mapResults(results);

//         searchResults$.next(newResults);
//         subject$.next(newResults);
//       },
//       error => subject$.error(error),
//       () => subject$.complete()
//     )
//     return (subject$);
//   }

//   addDefaultSearchOptions(options: PerformSearchOptions) : PerformSearchOptions {
//     let defaultOptions = <PerformSearchOptions>{
//       ...options,
//       includeSla: true,
//       includeNextDueTask: true
//     }
//     return (defaultOptions) ;
//   }

//   /**
//    * The data that comes back from the API is a columns defintion and an array
//    * of array of data. We need to map this into an array of objects with the column property
//    * id as the object key so that it's easier to handle by the table.
//    * @param model
//    */
//   private mapResults(model: FoundationWorkFindWorkItemResultModel): any[] {

//     let data: any[][] = model.results;
//     let results: any[];

//     if (model && model.total > 0 && model.results && model.columns) {
//       let colDefs: FoundationWorkFindWorkItemColumnDefModel[] = model.columns;

//       results = model.results.map<any>(r => {
//         let dataRow: any[] = r;
//         let objectRow: any = {};
//         for (var c: number = 0; c < colDefs.length; c++) {
//           let columnDef = colDefs[c];
//           objectRow[columnDef.code] = dataRow[c];
//         }
//         return (objectRow);
//       });
//     }
//     return results
//   }

//   /**
//    * Turn a list of properties into a filter object that can be passed to
//    * the work item search method.
//    * @param properties the list of properties from a SearchForm
//    */
//   buildFilter(properties: UIPropertyModel[]): SearchFilter {
//     let filter: SearchFilter = {
//       filters: []
//     };
//     if (properties && properties.length > 0) {
//       properties.forEach(p => {
//         if (p.value && p.value !== "") {
//           filter.filters.push(<SearchFilterExpression>{
//             field: p.propertyId,
//             value: p.value
//           });
//         }
//       });
//     }

//     return (filter);
//   }

}
